import React from "react";
import { usePreguntasCalidad } from "../../hooks";
import { Preguntas } from "../Preguntas";
import usePreguntasPuntualidad from "../../hooks/usePreguntasPuntualidad";
import usePreguntasComunicacionReportes from "../../hooks/usePreguntasComunicacionReportes";
import usePreguntasResponsabilidadManejoVehiculo from "../../hooks/usePreguntasResponsabilidadManejoVehiculo";
import usePreguntasActitudTrabajoEquipo from "../../hooks/usePreguntasActitudTrabajoEquipo";
import usePreguntasImagenRepresentacionEmpresa from "../../hooks/usePreguntasImagenRepresentacionEmpresa";

const PreguntasImagenRepresentacionEmpresa = () => {
	const { frmPreguntas, setPuntajeTotal } = usePreguntasImagenRepresentacionEmpresa();

	return (
		<Preguntas
			form={frmPreguntas}
			calcularPuntajeTotal={setPuntajeTotal}
			titulo="Imagen y representacion en la empresa (5/6)"
			opciones={[
				{ key: "usaElUniformeYEPP", label: "Usa el uniforme y EPP de manera adecuada en cada servicio" },
				{ key: "cumpleProtocolos", label: "Cumple con protocolos, políticas y procedimientos de la empresa" },
				{ key: "inspiraConfianza", label: "Inspira confianza por su conducta y responsabilidad" }
			]}
		/>
	);
};

export default PreguntasImagenRepresentacionEmpresa;
